import { t } from 'i18next';

/**
 *
 * @param text
 * @param namespace
 * @param data
 * @returns {string}
 */
function getTranslatedText(text, namespace, data = {}) {
    return t(text, { ns: namespace, ...data });
}

export default getTranslatedText;